export const STORE = 'store'
export const STORE_CART = 'storeCart'
export const STORE_UIID_CART = 'storeCartID'
export const FULFILLMENT = 'fulfillment'
